<section class="section" id="contact">
  <div class="container contact">
    <div class="section-box">
      <div class="mb-4" data-aos="fade-up" data-aos-duration="1000">
        <h3 class="contact-pre-title big-subtitle">
          05. {{ contactPretitle }}
        </h3>
        <h4 class="e-font contact-title big-title">
          {{ contactTitle }}
        </h4>
      </div>
      <p data-aos="fade-up" data-aos-duration="1000">
        {{ contactContent }}
      </p>
      <div class="mt-5">
        <a href="mailto:pavanmekala0129@gmail.com" target="_blank" class="main-btn" data-aos="fade-up"
          data-aos-duration="1000">
          {{ contactBtnText }}
        </a>
      </div>
    </div>
  </div>
</section>